import React from 'react';
import PropTypes from 'prop-types';
import ButtonIcon from '../../IconButton';
import styles from './index.module.scss';
import cn from 'classnames';

const MenuControlButton = ({ title, className, component, onClick }) => {
  return (
    <ButtonIcon
      title={title}
      className={cn(styles.menuButtonWrapper, className)}
      component={component}
      onClick={onClick}
    />
  );
};

export default MenuControlButton;

MenuControlButton.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  onClick: PropTypes.func,
};
